import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import SurveyExport from "../model/SurveyExport";

const ExportSurveyApiService = async (
  request: number
): Promise<SurveyExport> => {
  const url = `/forms/${request}/export/`;
  const { data, headers } = await axios.get(url);
  return {
    data,
    filename: headers["content-disposition"].split('filename="')[1],
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useExportSurveyApiService = () =>
  // eslint-disable-next-line
  useMutation<SurveyExport, AxiosError, number>(ExportSurveyApiService, {
    mutationKey: ["ExportSurveyApiService"],
  });
export default useExportSurveyApiService;
